// useToggleSpinner.ts (din fil)
import { useEffect } from "react";
import { setHideSpinner, setShowSpinner } from "../store/ganttChart";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { useSolutionPlanView } from "./useSolutionPlanView";

/**
 * Toggle spinner based on viewstate.
 */
export const useToggleGanttChartSpinner = () => {
  const planViewState = useSolutionPlanView();
  const dispatch = useAppDispatch();
  const { showSpinner } = useAppSelector((state) => state.ganttChartSlice);

  useEffect(() => {
    if (planViewState.status === "loading" && !showSpinner) {
      dispatch(setShowSpinner());
      return;
    }

    if (["missing", "error"].includes(planViewState.status) && showSpinner) {
      dispatch(setHideSpinner());
    }
  }, [planViewState.status, showSpinner, dispatch]);
};
